/**
 * Built-in effect `noise` (W2-01b; P§5.2): per-pixel random UV jitter. Reimplemented from the behaviour (badged
 * approximate).
 *
 * Every render-target pixel reads the screen at a random offset of up to `power` (fraction of the screen) in x and
 * y. The pattern depends only on the pixel and `seed`: it stands still unless `seed` is animated.
 */

import { m } from './builtinFx.messages';
import { defineBuiltin, HASH12, SAMPLE_SCREEN } from './shared';

export const noise = defineBuiltin({
  name: 'noise',
  label: { key: m.noise },
  description: { key: m.noiseDesc },
  inputs: [],
  uniforms: [
    { name: 'seed', type: 'float', default: 81, min: 0, max: 1000, label: { key: m.noiseSeed } },
    { name: 'power', type: 'float', default: 0.03, hint: '0..1', min: 0, max: 1, label: { key: m.noisePower } },
  ],
  helpers: [SAMPLE_SCREEN, HASH12],
  main: `
void main() {
  vec2 cell = floor(gl_FragCoord.xy) + vec2(seed, seed * 1.618);
  vec2 jitter = vec2(hash12(cell), hash12(cell + vec2(17.13, 41.71))) * 2.0 - 1.0;
  gl_FragColor = sampleScreen(uv + jitter * power);
}`,
});
